export enum MobileSecondaryNavStatus {
    ReferenceContent = 0,
    UserSettingsContent = 1,
    ShareSpaceContent = 2,
    SecondaryNavContent = 3,
    BookviewSearchPanel = 4,
}
